import {Checkbox as $b50e47f9c64ebdde$export$48513f6b9f8ce62d} from "../checkbox/Checkbox.mjs";
import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import {ClearSlots as $62024859ff9f1f8a$export$ceb145244332b7a2, SlotProvider as $62024859ff9f1f8a$export$8107b24b91795686} from "../utils/Slots.mjs";
import {Grid as $572f9fec526c2697$export$ef2184bd89960b14} from "../layout/Grid.mjs";
import "./styles.css";
import $6MMFg$styles_cssmjs from "./styles_css.mjs";
import {ListViewContext as $9710157b2ac3a032$export$870039b0abfe3de0} from "./ListView.mjs";
import {Provider as $71dfb0e0358a12de$export$2881499e37b75b9a} from "../provider/Provider.mjs";
import {Text as $f8cc90fea9436c19$export$5f1af8db9871e1d6} from "../text/Text.mjs";
import {useHasChild as $f57c7d8d50bdc255$export$e52e2242b6d0f1d4} from "../utils/useHasChild.mjs";
import $6MMFg$spectrumiconsuiChevronLeftMedium from "@spectrum-icons/ui/ChevronLeftMedium";
import $6MMFg$spectrumiconsuiChevronRightMedium from "@spectrum-icons/ui/ChevronRightMedium";
import {CSSTransition as $6MMFg$CSSTransition} from "react-transition-group";
import {FocusRing as $6MMFg$FocusRing} from "react-aria/FocusRing";
import {isFocusVisible as $6MMFg$isFocusVisible} from "react-aria/private/interactions/useFocusVisible";
import $6MMFg$spectrumiconsuiListGripper from "@spectrum-icons/ui/ListGripper";
import {mergeProps as $6MMFg$mergeProps} from "react-aria/mergeProps";
import $6MMFg$react, {useContext as $6MMFg$useContext, useRef as $6MMFg$useRef} from "react";
import {useButton as $6MMFg$useButton} from "react-aria/useButton";
import {useFocusRing as $6MMFg$useFocusRing} from "react-aria/useFocusRing";
import {useGridListItem as $6MMFg$useGridListItem, useGridListSelectionCheckbox as $6MMFg$useGridListSelectionCheckbox} from "react-aria/useGridList";
import {useHover as $6MMFg$useHover} from "react-aria/useHover";
import {useLocale as $6MMFg$useLocale} from "react-aria/I18nProvider";
import {useVisuallyHidden as $6MMFg$useVisuallyHidden} from "react-aria/VisuallyHidden";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 






















function $ae690085abfeeeb8$export$c6bde0c04b033c0e(props) {
    let { item: item, isEmphasized: isEmphasized } = props;
    let { state: state, dragState: dragState, dropState: dropState, isListDraggable: isListDraggable, isListDroppable: isListDroppable, layout: layout, dragAndDropHooks: dragAndDropHooks, loadingState: loadingState } = (0, $6MMFg$useContext)((0, $9710157b2ac3a032$export$870039b0abfe3de0));
    let { direction: direction } = (0, $6MMFg$useLocale)();
    let rowRef = (0, $6MMFg$useRef)(null);
    let checkboxWrapperRef = (0, $6MMFg$useRef)(null);
    let { isFocusVisible: isFocusVisibleWithin, focusProps: focusWithinProps } = (0, $6MMFg$useFocusRing)({
        within: true
    });
    let { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $6MMFg$useFocusRing)();
    let { rowProps: rowProps, gridCellProps: gridCellProps, isPressed: isPressed, descriptionProps: descriptionProps, isSelected: isSelected, isDisabled: isDisabled, allowsSelection: allowsSelection, hasAction: hasAction } = (0, $6MMFg$useGridListItem)({
        node: item,
        isVirtualized: true,
        shouldSelectOnPressUp: isListDraggable
    }, state, rowRef);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $6MMFg$useHover)({
        isDisabled: !allowsSelection && !hasAction
    });
    let { checkboxProps: checkboxProps } = (0, $6MMFg$useGridListSelectionCheckbox)({
        key: item.key
    }, state);
    let hasDescription = (0, $f57c7d8d50bdc255$export$e52e2242b6d0f1d4)(`.${(0, ($parcel$interopDefault($6MMFg$styles_cssmjs)))['react-spectrum-ListViewItem-description']}`, rowRef);
    let draggableItem = null;
    if (isListDraggable && dragAndDropHooks && dragState) {
        draggableItem = dragAndDropHooks.useDraggableItem({
            key: item.key,
            hasDragButton: true
        }, dragState);
        if (isDisabled) draggableItem = null;
    }
    let isDropTarget = false;
    let dropIndicator = null;
    let dropIndicatorRef = (0, $6MMFg$useRef)(null);
    if (isListDroppable && dragAndDropHooks && dropState) {
        let target = {
            type: 'item',
            key: item.key,
            dropPosition: 'on'
        };
        isDropTarget = dropState.isDropTarget(target);
        dropIndicator = dragAndDropHooks.useDropIndicator({
            target: target
        }, dropState, dropIndicatorRef);
    }
    let dragButtonRef = (0, $6MMFg$react).useRef(null);
    let { buttonProps: buttonProps } = (0, $6MMFg$useButton)({
        ...draggableItem?.dragButtonProps,
        elementType: 'div'
    }, dragButtonRef);
    let chevron = direction === 'ltr' ? /*#__PURE__*/ (0, $6MMFg$react).createElement((0, $6MMFg$spectrumiconsuiChevronRightMedium), {
        "aria-hidden": "true",
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($6MMFg$styles_cssmjs))), 'react-spectrum-ListViewItem-parentIndicator', {
            'react-spectrum-ListViewItem-parentIndicator--hasChildItems': item.props.hasChildItems,
            'is-disabled': !hasAction
        })
    }) : /*#__PURE__*/ (0, $6MMFg$react).createElement((0, $6MMFg$spectrumiconsuiChevronLeftMedium), {
        "aria-hidden": "true",
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($6MMFg$styles_cssmjs))), 'react-spectrum-ListViewItem-parentIndicator', {
            'react-spectrum-ListViewItem-parentIndicator--hasChildItems': item.props.hasChildItems,
            'is-disabled': !hasAction
        })
    });
    let showCheckbox = state.selectionManager.selectionMode !== 'none' && state.selectionManager.selectionBehavior === 'toggle';
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $6MMFg$useVisuallyHidden)();
    const mergedProps = (0, $6MMFg$mergeProps)(rowProps, draggableItem?.dragProps, hoverProps, focusWithinProps, focusProps);
    // Remove tab index from list row if performing a screenreader drag. This prevents TalkBack from focusing the row,
    // allowing for single swipe navigation between row drop indicator
    if (dragAndDropHooks?.isVirtualDragging?.()) mergedProps.tabIndex = undefined;
    let isFirstRow = item.prevKey == null;
    let isLastRow = item.nextKey == null;
    // Figure out if the ListView content is equal or greater in height to the container. If so, we'll need to round the bottom
    // border corners of the last row when selected and we can get rid of the bottom border if it isn't selected to avoid border overlap
    // with bottom border
    let isFlushWithContainerBottom = false;
    if (isLastRow && loadingState !== 'loadingMore') {
        if (layout.getContentSize()?.height >= (layout.virtualizer?.visibleRect.height ?? 0)) isFlushWithContainerBottom = true;
    }
    // previous item isn't selected
    // and the previous item isn't focused or, if it is focused, then if focus globally isn't visible or just focus isn't in the listview
    let roundTops = !(item.prevKey != null && state.selectionManager.isSelected(item.prevKey)) && (state.selectionManager.focusedKey !== item.prevKey || !((0, $6MMFg$isFocusVisible)() && state.selectionManager.isFocused));
    let roundBottoms = !(item.nextKey != null && state.selectionManager.isSelected(item.nextKey)) && (state.selectionManager.focusedKey !== item.nextKey || !((0, $6MMFg$isFocusVisible)() && state.selectionManager.isFocused));
    let content = typeof item.rendered === 'string' ? /*#__PURE__*/ (0, $6MMFg$react).createElement((0, $f8cc90fea9436c19$export$5f1af8db9871e1d6), null, item.rendered) : item.rendered;
    if (isDisabled) content = /*#__PURE__*/ (0, $6MMFg$react).createElement((0, $71dfb0e0358a12de$export$2881499e37b75b9a), {
        isDisabled: true
    }, content);
    return /*#__PURE__*/ (0, $6MMFg$react).createElement("div", {
        ...mergedProps,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($6MMFg$styles_cssmjs))), 'react-spectrum-ListView-row', {
            'focus-ring': isFocusVisible,
            'round-tops': roundTops || isHovered && !isSelected && state.selectionManager.focusedKey !== item.key,
            'round-bottoms': roundBottoms || isHovered && !isSelected && state.selectionManager.focusedKey !== item.key
        }),
        ref: rowRef
    }, /*#__PURE__*/ (0, $6MMFg$react).createElement("div", {
        // TODO: refactor the css here now that we are focusing the row?
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($6MMFg$styles_cssmjs))), 'react-spectrum-ListViewItem', {
            'is-active': isPressed,
            'is-focused': isFocusVisibleWithin,
            'focus-ring': isFocusVisible,
            'is-hovered': isHovered,
            'is-selected': isSelected,
            'is-disabled': isDisabled,
            'is-prev-selected': item.prevKey != null && state.selectionManager.isSelected(item.prevKey),
            'is-next-selected': item.nextKey != null && state.selectionManager.isSelected(item.nextKey),
            'react-spectrum-ListViewItem--highlightSelection': state.selectionManager.selectionBehavior === 'replace' && (isSelected || item.nextKey != null && state.selectionManager.isSelected(item.nextKey)),
            'react-spectrum-ListViewItem--dropTarget': !!isDropTarget,
            'react-spectrum-ListViewItem--firstRow': isFirstRow,
            'react-spectrum-ListViewItem--lastRow': isLastRow,
            'react-spectrum-ListViewItem--isFlushBottom': isFlushWithContainerBottom,
            'react-spectrum-ListViewItem--hasDescription': hasDescription
        }),
        ...gridCellProps
    }, /*#__PURE__*/ (0, $6MMFg$react).createElement((0, $572f9fec526c2697$export$ef2184bd89960b14), {
        UNSAFE_className: (0, ($parcel$interopDefault($6MMFg$styles_cssmjs)))['react-spectrum-ListViewItem-grid']
    }, isListDraggable && /*#__PURE__*/ (0, $6MMFg$react).createElement("div", {
        className: (0, ($parcel$interopDefault($6MMFg$styles_cssmjs)))['react-spectrum-ListViewItem-draghandle-container']
    }, !isDisabled && /*#__PURE__*/ (0, $6MMFg$react).createElement((0, $6MMFg$FocusRing), {
        focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($6MMFg$styles_cssmjs))), 'focus-ring')
    }, /*#__PURE__*/ (0, $6MMFg$react).createElement("div", {
        ...buttonProps,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($6MMFg$styles_cssmjs))), 'react-spectrum-ListViewItem-draghandle-button'),
        style: !isFocusVisibleWithin ? {
            ...visuallyHiddenProps.style
        } : {},
        ref: dragButtonRef,
        draggable: "true"
    }, /*#__PURE__*/ (0, $6MMFg$react).createElement((0, $6MMFg$spectrumiconsuiListGripper), null)))), isListDroppable && !dropIndicator?.isHidden && /*#__PURE__*/ (0, $6MMFg$react).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        ...dropIndicator?.dropIndicatorProps,
        ref: dropIndicatorRef
    }), /*#__PURE__*/ (0, $6MMFg$react).createElement((0, $6MMFg$CSSTransition), {
        in: showCheckbox,
        unmountOnExit: true,
        classNames: {
            enter: (0, ($parcel$interopDefault($6MMFg$styles_cssmjs)))['react-spectrum-ListViewItem-checkbox--enter'],
            enterActive: (0, ($parcel$interopDefault($6MMFg$styles_cssmjs)))['react-spectrum-ListViewItem-checkbox--enterActive'],
            exit: (0, ($parcel$interopDefault($6MMFg$styles_cssmjs)))['react-spectrum-ListViewItem-checkbox--exit'],
            exitActive: (0, ($parcel$interopDefault($6MMFg$styles_cssmjs)))['react-spectrum-ListViewItem-checkbox--exitActive']
        },
        timeout: 160,
        nodeRef: checkboxWrapperRef
    }, /*#__PURE__*/ (0, $6MMFg$react).createElement("div", {
        ref: checkboxWrapperRef,
        className: (0, ($parcel$interopDefault($6MMFg$styles_cssmjs)))['react-spectrum-ListViewItem-checkboxWrapper']
    }, /*#__PURE__*/ (0, $6MMFg$react).createElement((0, $b50e47f9c64ebdde$export$48513f6b9f8ce62d), {
        ...checkboxProps,
        UNSAFE_className: (0, ($parcel$interopDefault($6MMFg$styles_cssmjs)))['react-spectrum-ListViewItem-checkbox'],
        isEmphasized: isEmphasized
    }))), /*#__PURE__*/ (0, $6MMFg$react).createElement((0, $62024859ff9f1f8a$export$8107b24b91795686), {
        slots: {
            text: {
                UNSAFE_className: (0, ($parcel$interopDefault($6MMFg$styles_cssmjs)))['react-spectrum-ListViewItem-content']
            },
            description: {
                UNSAFE_className: (0, ($parcel$interopDefault($6MMFg$styles_cssmjs)))['react-spectrum-ListViewItem-description'],
                ...descriptionProps
            },
            illustration: {
                UNSAFE_className: (0, ($parcel$interopDefault($6MMFg$styles_cssmjs)))['react-spectrum-ListViewItem-thumbnail']
            },
            image: {
                UNSAFE_className: (0, ($parcel$interopDefault($6MMFg$styles_cssmjs)))['react-spectrum-ListViewItem-thumbnail']
            },
            actionButton: {
                UNSAFE_className: (0, ($parcel$interopDefault($6MMFg$styles_cssmjs)))['react-spectrum-ListViewItem-actions'],
                isQuiet: true
            },
            actionGroup: {
                UNSAFE_className: (0, ($parcel$interopDefault($6MMFg$styles_cssmjs)))['react-spectrum-ListViewItem-actions'],
                isQuiet: true,
                density: 'compact'
            },
            actionMenu: {
                UNSAFE_className: (0, ($parcel$interopDefault($6MMFg$styles_cssmjs)))['react-spectrum-ListViewItem-actionmenu'],
                isQuiet: true
            }
        }
    }, content, /*#__PURE__*/ (0, $6MMFg$react).createElement((0, $62024859ff9f1f8a$export$ceb145244332b7a2), null, chevron)))));
}


export {$ae690085abfeeeb8$export$c6bde0c04b033c0e as ListViewItem};
//# sourceMappingURL=ListViewItem.mjs.map
